<template lang="pug">
  div.timeline
    div.timeline__left
      div.timeline__date {{ data.startDate | formatDate }}
    div.timeline__right
      //- div.timeline__info {{ data.roles }}
      div.timeline__title {{ data.name }}
      div.timeline__description {{ data.description }}
</template>

<script>
import moment from 'moment'
export default {
  name: 'Timeline',
  data () {
    return {
    }
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  filters: {
    formatDate (date) {
      const formatedDate = moment(date).format('HH.mm')
      return formatedDate + 'HS'
    }
  }

}
</script>

<style scoped lang="scss">
  .timeline{
    display: flex;
    margin-bottom: 28px;

    &__right{
      margin-left: 24px;
    }

    &__date{
      border-radius: 6px;
      background-color: $--color-primary-light-8;
      padding: 4px 16px;
      color: $--color-primary;
      font-size: 9px;
      font-weight: 500;
      line-height: 16px;
      text-transform: uppercase;
    }

    &__info{
      color: $--color--grey-medium;
      font-size: 9px;
      font-weight: 500;
      line-height: 16px;
      text-transform: uppercase;
    }

    &__title{
      color: $--color-grey-dark;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.2px;
      line-height: 21px;
      //margin-top: 4px;
    }

    &__description{
      color: $--color--grey-medium;
      font-size: 12px;
      line-height: 24px;
      margin-top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Timeline.vue